import { type ColumnDef } from '@tanstack/react-table';

import { ChaveAcesso } from '@/ui/components/chave-acesso';
import { Badge } from '@/ui/primitives/badge';
import { type ItemLote } from '@fiscoai/contracts';

import { ROTULO_RESULTADO } from './rotulos';

export const colunasItens: ColumnDef<ItemLote>[] = [
  {
    id: 'arquivo',
    header: 'Arquivo ou linha',
    cell: ({ row }) => <span className="truncate font-medium">{row.original.nomeArquivo}</span>,
  },
  {
    id: 'chave',
    header: 'Chave',
    cell: ({ row }) =>
      row.original.chave ? (
        <ChaveAcesso chave={row.original.chave} compacta />
      ) : (
        <span className="text-texto-fraco">—</span>
      ),
  },
  {
    id: 'resultado',
    header: 'Resultado',
    cell: ({ row }) => {
      const r = ROTULO_RESULTADO[row.original.resultado];
      return (
        <Badge tom={r.tom} className="animate-surgir" key={row.original.resultado}>
          {r.rotulo}
        </Badge>
      );
    },
  },
  {
    id: 'mensagem',
    header: 'Detalhe',
    cell: ({ row }) => (
      <span className="text-sm text-texto-suave">{row.original.mensagem ?? ''}</span>
    ),
  },
];
